import { defineMessages } from 'react-intl';

export const ordersTabsMessages = defineMessages({
  ordersTabLabel: {
    defaultMessage: 'Orders',
    description: 'Orders Screen | Orders tab title',
  },
  ordersTabA11yLabel: {
    defaultMessage: 'Show orders tab',
    description: 'Orders Screen | Orders tab a11y label',
  },
  digitalOrdersTabLabel: {
    defaultMessage: 'Digital',
    description: 'Orders Screen | Digital orders tab title',
  },
  digitalOrdersTabA11yLabel: {
    defaultMessage: 'Show digital orders tab',
    description: 'Orders Screen | Digital orders tab a11y label',
  },
  inStoreOrdersTabLabel: {
    defaultMessage: 'In-Store',
    description: 'Orders Screen | In-store orders tab title',
  },
  inStoreOrdersTabA11yLabel: {
    defaultMessage: 'Show in-store orders tab',
    description: 'Orders Screen | In-store orders tab a11y label',
  },
  giftCardsTabLabel: {
    defaultMessage: 'Gift Cards',
    description: 'Orders Screen | Gift cards tab title',
  },
  giftCardsTabA11yLabel: {
    defaultMessage: 'Show gift cards tab',
    description: 'Orders Screen | Gift cards tab a11y label',
  },
});
